import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-20 px-4 bg-brand-dark text-brand-bg relative overflow-hidden" data-id="element-111">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-dark via-brand-accent to-brand-dark" data-id="element-112"></div>
      <div className="max-w-3xl mx-auto text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-114">
          <div className="flex justify-center mb-6" data-id="element-115">
            <div className="bg-brand-accent/20 p-4 rounded-full" data-id="element-116">
              <ClockIcon className="w-10 h-10 text-brand-accent" data-id="element-117" />
            </div>
          </div>
          <p className="text-xl md:text-2xl leading-relaxed mb-8 font-serif text-stone-300" data-id="element-118">
            "Son las 6:15 PM. Llevas 10 horas trabajando, tus hijos tienen
            hambre y tú no tienes fuerza ni para picar una cebolla. Miras la
            nevera vacía, sientes esa punzada de culpa y terminas gastando $45
            en comida rápida que ni siquiera es buena para tu familia."
          </p>

          <div className="w-24 h-1 bg-brand-accent mx-auto mb-8 rounded-full" data-id="element-119"></div>

          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-120">
            Este ciclo se detiene hoy.
          </h2>

          <p className="text-lg text-stone-400 font-sans max-w-2xl mx-auto" data-id="element-121">
            No necesitas ser un chef, necesitas un{' '}
            <strong className="text-brand-bg font-bold" data-id="element-122">
              sistema de supervivencia
            </strong>{' '}
            diseñado para la vida real en Estados Unidos.
          </p>
        </motion.div>
      </div>
    </section>;
}